import commonActions from '@/store/data/common/actions'

const actions = {
    ...commonActions
}

export default actions
